export default __webpack_public_path__ + "static/media/hd_ic_plaza.18b5016d.svg";